import { initialRouteState, RouterState, RouterStateUrl } from "@app/root-store/router.state";
import { createFeatureSelector, createSelector } from "@ngrx/store";

export const getActiveRouterState = createFeatureSelector<RouterStateUrl>("activeRoute");
export const getRouterState = createFeatureSelector<RouterState>("routerReducer");

export const getQueryParams = createSelector(getRouterState, (router: RouterState = initialRouteState) => router.state?.queryParams);

export const getUrl = createSelector(getRouterState, (router: RouterState = initialRouteState) => router.state?.url);

export const getParams = createSelector(getRouterState, (router: RouterState = initialRouteState) => router.state?.params);

const getProp = (state, propToFind) => {
    if (state.children && state.children.length) {
        let val: string;
        state.children.forEach(child => {
            val = getProp(child, propToFind);
        });
        return val;
    }

    return state[propToFind];
};

export const getParam = (state, paramToFind: string): string => {
    if (state.params?.[paramToFind] === undefined) {
        if (state.children) {
            let val: string;
            state.children.find(child => {
                val = getParam(child, paramToFind);
                return val;
            });
            return val;
        }

        return undefined;
    }
    return state.params?.[paramToFind];
};

const matchUrl = (state, urlToMatch, depth) => {
    if (state.url === urlToMatch) {
        return true;
    }
    if (depth > 0) {
        if (state.children) {
            return state.children.some(child => matchUrl(child, urlToMatch, depth - 1));
        }

        return undefined;
    }
    return undefined;
};

const getChildRouteAtDepth = (state, depth) =>
    state
        ? state.reduce((result, route) => {
              if (depth > 0 && route.children.length) {
                  return getChildRouteAtDepth(route.children, depth - 1);
              }
              if (depth === 0) {
                  return route.url;
              }
              return false;
          }, null)
        : "";

export const getChildRoute = (depth: number) =>
    createSelector(getRouterState, (router: RouterState = initialRouteState) => getChildRouteAtDepth(router.state.children, depth - 1));

export const selectUrlParam = (key: string) =>
    createSelector(getRouterState, (router: RouterState = initialRouteState) => getParam(router.state, key));

export const findIdParam = createSelector(getRouterState, (router: RouterState = initialRouteState) => getParam(router.state, "id"));

export const getTitle = createSelector(getActiveRouterState, (state: RouterStateUrl = initialRouteState.state) => getProp(state, "title"));

export const getBackAction = createSelector(getActiveRouterState, (state: RouterStateUrl = initialRouteState.state) =>
    getProp(state, "backAction")
);
